import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper/index";

import { FormUtils as GetAllFormFields, TableComp } from "sz-react-utils";

import moment from "moment";
import {
    Button,
    Card,
    notification,
    Row,
    Col,
    Form,
    Icon,
    Select,
    Switch,
    Table,
    Tabs,
    Popover,
} from "antd";
import _ from "lodash";

import Request, { API_URL } from "../../request";
import { connect } from "react-redux";

const Option = Select.Option;

@Form.create()
class WhatsappTriggers extends React.Component {
    state = {
        ifCheckboxChecked: [],
        triggerFields: [],
        setFormFieldValuesObject: {}
    };

    componentDidMount() {
        this.loadAllTemplates();
        setTimeout(() => {
            this.loadTriggers()
        }, 50)
    }


    loadTriggers = async () => {
        let response = await Request.getCommunicationSettings();
        this.setState({ setFormFieldValuesObject: (response.doc.triggers ? response.doc.triggers : {}) })
    }



    loadAllTemplates = async () => {
        let params = {
            results: 1000,
            count: 1000,
        };
        let templateArr = await Request.loadTemplates(params);
        let whatsappTemplates = [];
        let emailTemplates = [];
        let smsTemplates = [];
        _.each(templateArr.data, (template) => {
            if (template.type === "Whatsapp") {
                whatsappTemplates.push({ value: template._id, label: template.templateName },);
            } else if (template.type === "Email") {
                emailTemplates.push({ value: template._id, label: template.templateName },);
            } else if (template.type === "SMS") {
                smsTemplates.push({ value: template._id, label: template.templateName },);
            }
        });


        let triggerFields = [
            {
                title: "Welcome Abroad",
                key: "welcome_abroad",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Counsellor Assigned",
                key: "counsellor_assigned",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Courses Shortlisted",
                key: "course_shortlisted",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "More Course Options Required",
                key: "more_course_added",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Consultancy Fee (Country Wise)",
                key: "countrywise_consultancyFee",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Consultancy Fee Paid",
                key: "cousultancyFeePaid",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Admission Person Assigned",
                key: "admissionPerson_assigned",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Submit Documents & Apply Soon",
                key: "submitDocuments_applySoon",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Application to be Processed",
                key: "application_processed",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Application has been Processed",
                key: "application_has_processed",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Additional Documents Required",
                key: "additional_documents_required",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Interview Required",
                key: "interview_required",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Offer Letter Received",
                key: "offer_letter_received",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Offer Denied",
                key: "offer_denied",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Team Assigned",
                key: "visa_team_assigned",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Tution Fee Paid",
                key: "tution_fee_paid",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "COE Received",
                key: "coe_received",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Consultancy Fee Pending",
                key: "consultancy_fee_pending",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Required Documents for Visa Application",
                key: "required_documents_for_visa",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Open Your GIC Account",
                key: "open_your_gic_account",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "GIC Certificate Received",
                key: "gic_certificate_received",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "CAQ Waiting",
                key: "caq_waiting",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "CAQ Received",
                key: "caq_received",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "CAS Letter Received",
                key: "cas_letter_received",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "LOA Received",
                key: "loa_received",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Application Filled",
                key: "visa_application_filed",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Approved",
                key: "visa_approved",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Denied",
                key: "visa_denied",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Approved (To Counsellor)",
                key: "visa_approved_to_counsellor",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Approved (To Branch)",
                key: "visa_approved_to_branch",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Denied (To Counsellor)",
                key: "visa_denied_to_counsellor",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Account Payment Receipt to Student",
                key: "account_payment_receipt_student",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Facebook Lead Welcome ",
                key: "facebook_lead_welcome",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Facebook Lead Demo Reminder",
                key: "facebook_lead_demo_reminder",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Overdue Followups Reminder to Employees",
                key: "employees_overdue_reminder",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Rating Reminder to Employees",
                key: "rating_reminder_employees",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Check Unread Whatsapp Messages Employees",
                key: "check_unread_whatsapp_message",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Task Pending Whatsapp Messages Employees",
                key: "task_pending_whatsapp_message",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "New University Publised Notification",
                key: "new_university_published_message",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "University Expiring Notification",
                key: "university_expiring_message",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Move Desk Notification",
                key: "move_desk_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Enrolled In University Notification",
                key: "enrolled_in_university_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Visa Parked Leads Notification",
                key: "visa_parked_leads_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Invoice Not Generated Notification",
                key: "invoice_not_generated_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: 'Invoice Generated Notification to Branch/SubAgent',
                key: 'invoice_generated_notification_branch',
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: 'Invoice Approved Notification to Branch/SubAgent',
                key: 'invoice_approved_notification_branch',
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: 'Invoice Submitted Notification to Branch/SubAgent',
                key: 'invoice_submitted_notification_branch',
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: 'Invoice Status Update Notification to Branch/SubAgent',
                key: 'invoice_status_update_notification_branch',
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Invoice Cleared Notification to Branch/SubAgent",
                key: "invoice_cleared_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Branch Invoice Request Generated Notification",
                key: "branch_invoice_request_generated_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Branch Invoice Approved Notification",
                key: "branch_invoice_approved_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
            {
                title: "Untouched Leads Notification",
                key: "untouched_leads_notification",
                whatsApp: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: whatsappTemplates,
                    },
                ],
                email: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: emailTemplates,
                    },
                ],
                sms: [
                    {
                        key: "_switch_key_",
                        type: "switch",
                    },
                    {
                        key: "_select_key_",
                        type: "select",
                        options: smsTemplates,
                    },
                ],
            },
        ];

        this.setState({ triggerFields });
    };

    handleSubmit = (e) => {
        let { form } = this.props;
        let { setFormFieldValuesObject } = this.state
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let response = await Request.addCommunicationSettings({ triggers: setFormFieldValuesObject })
            if (response.success) {
                notification.success({
                    message: 'Communication Setting Added',
                });
            } else {
                notification.error({
                    messsage: 'Something Went Wrong',
                });
            }
        });
    };



    triggerOnChange = (key, input) => {
        let ifCheckboxChecked = this.state.ifCheckboxChecked;
        ifCheckboxChecked[key] = input;
        this.setState({ ifCheckboxChecked });
    }
    setFormFieldValues = (key, input) => {
        let setFormFieldValuesObject = this.state.setFormFieldValuesObject;
        setFormFieldValuesObject[key] = input;
        this.setState({ setFormFieldValuesObject });
    }

    render() {
        let {
            form: { setFieldsValue, getFieldDecorator },
        } = this.props;

        let { triggerFields, ifCheckboxChecked, setFormFieldValuesObject } = this.state;

        return (
            <PageHeaderWrapper title={"Communication Triggers"}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>Label</th>
                                    <th>Whatsapp</th>
                                    <th>Email</th>
                                    <th>Sms</th>
                                </tr>
                            </thead>
                            <tbody>
                                {triggerFields &&
                                    triggerFields.map((triggerField, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{triggerField.title}</td>
                                                <td>
                                                    {triggerField.whatsApp &&
                                                        triggerField.whatsApp.map((field, wfIndex) => {
                                                            let inputKey = triggerField.key + "" + field.key + "whatsApp";
                                                            return (
                                                                <div key={wfIndex}>
                                                                    {field.type == "switch" ? (
                                                                        <Form.Item>
                                                                            <Switch checked={setFormFieldValuesObject[inputKey] == undefined ? false : setFormFieldValuesObject[inputKey]} onChange={(e) => { this.triggerOnChange((triggerField.key + "_" + index + "_whatsApp"), e); this.setFormFieldValues(inputKey, e) }} />
                                                                        </Form.Item>
                                                                    ) : field.type == "select" ? (
                                                                        <Form.Item

                                                                        >
                                                                            <Select
                                                                                name={triggerField.key + "" + field.key + "whatsApp"}
                                                                                showSearch
                                                                                style={{ width: 200 }}
                                                                                placeholder="Search to Select"
                                                                                optionFilterProp="children"
                                                                                value={setFormFieldValuesObject[inputKey] || undefined}
                                                                                onChange={(e) => { this.setFormFieldValues(inputKey, e) }}
                                                                                disabled={ifCheckboxChecked[triggerField.key + "_" + index + "_whatsApp"] == true ? false : true}
                                                                                required={ifCheckboxChecked[triggerField.key + "_" + index + "_whatsApp"] == true ? false : true}
                                                                            >
                                                                                {
                                                                                    field.options && field.options.map((option, oPIndex) => {
                                                                                        return (<Select.Option value={option.value} key={oPIndex}>{option.label}</Select.Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </Form.Item>
                                                                    ) : null}
                                                                </div>
                                                            );
                                                        })}
                                                </td>
                                                <td>
                                                    {triggerField.email &&
                                                        triggerField.email.map((field, efIndex) => {
                                                            let emailInputKey = triggerField.key + "" + field.key + "email";
                                                            return (
                                                                <div key={efIndex}>
                                                                    {field.type == "switch" ? (
                                                                        <Form.Item>
                                                                            <Switch checked={setFormFieldValuesObject[emailInputKey] == undefined ? false : setFormFieldValuesObject[emailInputKey]} onChange={(e) => { this.triggerOnChange((triggerField.key + "_" + index + "_email"), e); this.setFormFieldValues(emailInputKey, e) }} />
                                                                        </Form.Item>
                                                                    ) : field.type == "select" ? (
                                                                        <Form.Item>
                                                                            <Select
                                                                                showSearch
                                                                                style={{ width: 200 }}
                                                                                placeholder="Search to Select"
                                                                                optionFilterProp="children"
                                                                                value={setFormFieldValuesObject[emailInputKey] || undefined}
                                                                                onChange={(e) => { this.setFormFieldValues(emailInputKey, e) }}
                                                                                disabled={ifCheckboxChecked[triggerField.key + "_" + index + "_email"] == true ? false : true}
                                                                                required={ifCheckboxChecked[triggerField.key + "_" + index + "_email"] == true ? false : true}
                                                                            >
                                                                                {
                                                                                    field.options && field.options.map((option, oPIndex) => {
                                                                                        return (<Select.Option value={option.value} key={oPIndex}>{option.label}</Select.Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </Form.Item>
                                                                    ) : null}
                                                                </div>
                                                            );
                                                        })}
                                                </td>
                                                <td>
                                                    {triggerField.sms &&
                                                        triggerField.sms.map((field, sfIndex) => {
                                                            let smsInputKey = triggerField.key + "" + field.key + "sms";
                                                            return (
                                                                <div key={sfIndex}>
                                                                    {field.type == "switch" ? (
                                                                        <Form.Item>
                                                                            <Switch checked={setFormFieldValuesObject[smsInputKey] == undefined ? false : setFormFieldValuesObject[smsInputKey]} onChange={(e) => { this.triggerOnChange((triggerField.key + "_" + index + "_sms"), e); this.setFormFieldValues(smsInputKey, e) }} />
                                                                        </Form.Item>
                                                                    ) : field.type == "select" ? (
                                                                        <Form.Item>
                                                                            <Select
                                                                                showSearch
                                                                                style={{ width: 200 }}
                                                                                placeholder="Search to Select"
                                                                                optionFilterProp="children"
                                                                                value={setFormFieldValuesObject[smsInputKey] || undefined}
                                                                                onChange={(e) => { this.setFormFieldValues(smsInputKey, e) }}
                                                                                disabled={ifCheckboxChecked[triggerField.key + "_" + index + "_sms"] == true ? false : true}
                                                                                required={ifCheckboxChecked[triggerField.key + "_" + index + "_sms"] == true ? false : true}
                                                                            >
                                                                                {
                                                                                    field.options && field.options.map((option, oPIndex) => {

                                                                                        return (<Select.Option value={option.value} key={oPIndex}>{option.label}</Select.Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </Form.Item>
                                                                    ) : null}
                                                                </div>
                                                            );
                                                        })}
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginBottom: 10 }}
                            loading={this.props.loading}
                        >
                            SAVE
                        </Button>
                    </Form>
                </Card>
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WhatsappTriggers);
